// Helpers para integração com WhatsApp

export const COOMFLONA_WHATSAPP = "5593991765579"; // formato internacional sem + nem espaços

function formatBRL(v) {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(Number(v || 0));
}

function formatDateBR(iso) {
    if (!iso) return "";
    const [y, m, d] = iso.split("-");
    return `${d}/${m}/${y}`;
}

// Gera mensagem da ficha de viagem
export function tripWhatsAppText(trip) {
    const datasStr = (trip.datas && trip.datas.length > 1)
        ? trip.datas.map(formatDateBR).join(", ")
        : formatDateBR(trip.data);
    const trajeto = trip.local_saida
        ? `${trip.local_saida} → ${trip.destino}`
        : trip.destino;
    const destinosExtras = (trip.destinos_extras || []).filter(Boolean);
    const lines = [
        "*🚗 COOMFLONA — Setor de Transporte*",
        "",
        `*Ficha de Viagem — ${trip.tipo === "fixo" ? "Contrato de Veículo" : "Diária"}*`,
        "",
        `👤 *Responsável:* ${trip.responsavel_nome}`,
        trip.cpf ? `📄 *CPF:* ${trip.cpf}` : "",
        `📍 *Trajeto:* ${trajeto}`,
        destinosExtras.length > 0 ? `➕ *Destinos adicionais:* ${destinosExtras.join(" • ")}` : "",
        `🚙 *Veículo:* ${trip.veiculo_modelo || ""} ${trip.veiculo_placa ? `(${trip.veiculo_placa})` : ""}`.trim(),
        `📅 *Data${(trip.datas && trip.datas.length > 1) ? "s" : ""}:* ${datasStr}`,
        trip.hora_saida ? `🕒 *Saída:* ${trip.hora_saida}` : "",
        trip.hora_entrada ? `🕓 *Chegada:* ${trip.hora_entrada}` : "",
        trip.dias && trip.dias > 1 ? `📆 *${trip.tipo === "fixo" ? "Meses" : "Dias"}:* ${trip.dias}` : "",
        trip.contrato_inicio && trip.contrato_fim ? `📋 *Contrato:* ${formatDateBR(trip.contrato_inicio)} a ${formatDateBR(trip.contrato_fim)}` : "",
        trip.km_saida != null && trip.km_chegada != null ? `🛣️ *KM rodados:* ${(trip.km_chegada - trip.km_saida).toLocaleString("pt-BR")} km` : "",
        trip.valor ? `💰 *Valor:* ${formatBRL(trip.valor)}` : "",
        trip.chave_pix ? `🔑 *Chave PIX:* ${trip.chave_pix}` : "",
        trip.observacoes ? `📝 *Obs:* ${trip.observacoes}` : "",
        "",
        `Ficha nº ${(trip.id || "").slice(0, 8).toUpperCase()}`,
    ].filter(Boolean);
    return lines.join("\n");
}

// Gera mensagem de lembrete de viagem
export function tripReminderText(trip) {
    const datasStr = (trip.datas && trip.datas.length > 1)
        ? trip.datas.map(formatDateBR).join(", ")
        : formatDateBR(trip.data);
    return [
        "*🔔 Lembrete de Viagem — COOMFLONA*",
        "",
        `Olá, ${trip.responsavel_nome}! 👋`,
        "",
        `Lembrete da sua viagem agendada:`,
        trip.local_saida ? `📍 *Saída:* ${trip.local_saida}` : "",
        `📍 *Destino:* ${trip.destino}`,
        `📅 *Data${(trip.datas && trip.datas.length > 1) ? "s" : ""}:* ${datasStr}`,
        trip.hora_saida ? `🕒 *Horário:* ${trip.hora_saida}` : "",
        `🚙 *Veículo:* ${trip.veiculo_placa}`,
        "",
        "Qualquer dúvida, entre em contato com o setor de transporte.",
    ].filter(Boolean).join("\n");
}

// Abre WhatsApp com mensagem pronta
// telefone: opcional - se fornecido, abre conversa direta; se vazio, abre seletor
export function openWhatsApp(text, telefone = "") {
    const phone = (telefone || "").replace(/\D/g, "");
    const fullPhone = phone && phone.length >= 10 ? (phone.length <= 11 ? `55${phone}` : phone) : "";
    const url = fullPhone
        ? `https://wa.me/${fullPhone}?text=${encodeURIComponent(text)}`
        : `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank");
}
